import React, {useEffect, forwardRef, useImperativeHandle} from "react";
import "./style.scss";
import {generateImageUrl} from "../../utils/imageUtils";

export const Image = forwardRef(({
                                     alt = "",
                                     style = {},
                                     quality = 100,
                                     src, width, height,
                                     className, otherParams = {},
                                     onLoadSuccess = () => {},
                                     defaultLoad = true,
                                     type = "webp",
                                     onClick = () => {
                                     },
                                     onMouseEnter = () => {
                                     },
                                     onMouseLeave = () => {
                                     },
                                     updateRef = () => {
                                     },
                                     formatSize = 1,
                                 }, ref) => {

    if (!src) return null;
    const [isLoaded, setIsLoaded] = React.useState(defaultLoad);
    const imageRef = React.useRef(null);

    useImperativeHandle(ref, () => ({
        updateSrc: () => {

        },
    }));

    const [url, setUrl] = React.useState("");
    
    useEffect(() => {
        if (imageRef) {
            updateRef(imageRef, setIsLoaded);
        }
    }, [imageRef]);

    useEffect(() => {
        // 获取当前元素的实际尺寸
        let curDomWidth = width;
        let curDomHeight = height;
        if (!width) {
            curDomWidth = imageRef.current?.offsetWidth;
        }
        if (!height) {
            curDomHeight = imageRef.current?.offsetHeight;
        }

        // 使用工具函数生成图片URL
        const finalUrl = generateImageUrl(src, {
            quality,
            formatSize
        });
        
        setUrl(finalUrl);
    }, [src, width, height, quality, formatSize]);

    return <img
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onLoad={onLoadSuccess}
        style={style}
        className={className}
        src={isLoaded ? url : ""}
        alt={alt}
        width={width}
        height={height}
        onClick={onClick}
        ref={imageRef}
    />;
});

Image.propTypes = {};
